<template>
	<component :is="as" class="_open-close-icon" :data-open="open?.toString()" :data-theme="theme" />
</template>

<script setup>
import { defineThemeProp } from '@/helpers/vue'

defineProps({
	open: { type: Boolean, default: undefined },
	as: { type: String, default: 'span' },
	theme: defineThemeProp(),
})
</script>

<style lang="scss" scoped>
@use '../atoms.scss';

._open-close-icon {
	--size: #{rs(18, 18)};

	position: relative;

	width: var(--size);
	height: var(--size);

	transform: rotate(0deg);
	overflow: hidden;

	transition: transform 0.35s ease('power2', 'inOut') 0.05s;
	will-change: transform;

	&[data-theme='dark'] {
		--color: #{$white};
	}

	&[data-open='true'] {
		transform: rotate(90deg);

		&:before {
			transform: translateX(var(--size));
			opacity: 0.5;
		}
	}

	&:before,
	&:after {
		content: '';
		position: absolute;
		width: 100%;
		height: var(--width, 2px);
		top: calc(50% - 0.5 * var(--width, 2px));
		left: 0;

		background-color: var(--color, #{$black});

		transition: transform 0.25s ease('power2', 'inOut');
		transition-property: transform, opacity;

		will-change: transform;
	}

	&:after {
		transform: rotate(90deg);
		opacity: 1;
	}
}
</style>
